// extracted by mini-css-extract-plugin
module.exports = {"notfound_id":"not-found-page_notfound_id__1Yy2H","notfound":"not-found-page_notfound__2kzwh","notfound_404":"not-found-page_notfound_404__1l984"};